//import all the src buttons and hover buttons
import HomeSrcBtn from 'assets/images/buttons/menu-buttons-wim-eng.png';
import HomeSrcHoverBtn from 'assets/images/buttons/menu-buttons-wim-eng-hover.png';
import HomeSrcChnBtn from 'assets/images/buttons/menu-buttons-wim-Chn.png';
import HomeSrcChnHoverBtn from 'assets/images/buttons/menu-buttons-wim-Chn-hover.png';
import SchdSrcBtn from 'assets/images/buttons/menu-buttons-sch-eng.png';
import SchdSrcHoverBtn from 'assets/images/buttons/menu-buttons-sch-eng-hover.png';
import SchdSrcChnBtn from 'assets/images/buttons/menu-buttons-sch-Chn.png';
import SchdSrcChnHoverBtn from 'assets/images/buttons/menu-buttons-sch-Chn-hover.png';
import ActSrcBtn from 'assets/images/buttons/menu-buttons-act-eng.png';
import ActSrcHoverBtn from 'assets/images/buttons/menu-buttons-act-eng-hover.png';
import ActSrcChnBtn from 'assets/images/buttons/menu-buttons-act-Chn.png';
import ActSrcChnHoverBtn from 'assets/images/buttons/menu-buttons-act-Chn-hover.png';
import NewsSrcBtn from 'assets/images/buttons/menu-buttons-news-eng.png';
import NewsSrcHoverBtn from 'assets/images/buttons/menu-buttons-news-eng-hover.png';
import NewsSrcChnBtn from 'assets/images/buttons/menu-buttons-news-Chn.png';
import NewsSrcChnHoverBtn from 'assets/images/buttons/menu-buttons-news-Chn-hover.png';
import JnusSrcBtn from 'assets/images/buttons/menu-buttons-jnus-eng.png';
import JnusSrcHoverBtn from 'assets/images/buttons/menu-buttons-jnus-eng-hover.png';
import JnusSrcChnBtn from 'assets/images/buttons/menu-buttons-jnus-Chn.png';
import JnusSrcChnHoverBtn from 'assets/images/buttons/menu-buttons-jnus-Chn-hover.png';
import SponSrcBtn from 'assets/images/buttons/menu-buttons-spon-eng.png';
import SponSrcHoverBtn from 'assets/images/buttons/menu-buttons-spon-eng-hover.png';
import SponSrcChnBtn from 'assets/images/buttons/menu-buttons-spon-Chn.png';
import SponSrcChnHoverBtn from 'assets/images/buttons/menu-buttons-spon-Chn-hover.png';
import AbusSrcBtn from 'assets/images/buttons/menu-buttons-abus-eng.png';
import AbusSrcHoverBtn from 'assets/images/buttons/menu-buttons-abus-eng-hover.png';
import AbusSrcChnBtn from 'assets/images/buttons/menu-buttons-abus-Chn.png';
import AbusSrcChnHoverBtn from 'assets/images/buttons/menu-buttons-abus-Chn-hover.png';

export const MenuOptions = [
  {
    name: 'WIMSS',
    path: '/home',
    src: HomeSrcBtn,
    srcHovered: HomeSrcHoverBtn,
  },
  {
    name: 'ACTIVITIES',
    path: '/activities',
    src: ActSrcBtn,
    srcHovered: ActSrcHoverBtn,
  },
  {
    name: 'SCHEDULES',
    path: '/schedules',
    src: SchdSrcBtn,
    srcHovered: SchdSrcHoverBtn,
  },
  { name: 'NEWS', path: '/news', src: NewsSrcBtn, srcHovered: NewsSrcHoverBtn },
  {
    name: 'SPONSORS',
    path: '/sponsors',
    src: SponSrcBtn,
    srcHovered: SponSrcHoverBtn,
  },
  {
    name: 'ABOUT-US',
    path: '/about-us',
    src: AbusSrcBtn,
    srcHovered: AbusSrcHoverBtn,
  },
  {
    name: 'JOIN-US',
    path: '/join-us',
    src: JnusSrcBtn,
    srcHovered: JnusSrcHoverBtn,
  },
];

export const MenuOptionsChn = [
  {
    name: '爱城活力社',
    path: '/home',
    src: HomeSrcChnBtn,
    srcHovered: HomeSrcChnHoverBtn,
  },
  {
    name: '活动',
    path: '/activities',
    src: ActSrcChnBtn,
    srcHovered: ActSrcChnHoverBtn,
  },
  {
    name: '时间表',
    path: '/schedules',
    src: SchdSrcChnBtn,
    srcHovered: SchdSrcChnHoverBtn,
  },
  {
    name: '消息',
    path: '/news',
    src: NewsSrcChnBtn,
    srcHovered: NewsSrcChnHoverBtn,
  },
  {
    name: '赞助商',
    path: '/sponsors',
    src: SponSrcChnBtn,
    srcHovered: SponSrcChnHoverBtn,
  },
  {
    name: '关于我们',
    path: '/about-us',
    src: AbusSrcChnBtn,
    srcHovered: AbusSrcChnHoverBtn,
  },
  {
    name: '加入我们',
    path: '/join-us',
    src: JnusSrcChnBtn,
    srcHovered: JnusSrcChnHoverBtn,
  },
];
